<template>
  <div id="app">
    <nav class="navbar navbar-default navbar-fixed-top">
	  <div class="container">
		  <div class="con-info hidden-xs">
			联系电话（同微信）：<b>13031839005</b>
			邮箱：<b>kellong@meshnb.com</b>
			&nbsp;&nbsp;
			
			<div class="dropdown">
				<button id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					选择语言
					<span class="caret"></span>
				</button>
				<ul class="dropdown-menu" aria-labelledby="dLabel">
					<li><a class="" href="https://www.balanatwiremesh.com"><span class="flag_language-pic flag-en" :style="{backgroundImage:'url('+language_small+')'}"></span>English</a></li>
					<li><a class="" href="http://es.balanatwiremesh.com"><span class="flag_language-pic flag-es" :style="{backgroundImage:'url('+language_small+')'}"></span>Español</a></li>
					<li><a class="" href="http://pt.balanatwiremesh.com"><span class="flag_language-pic flag-pt" :style="{backgroundImage:'url('+language_small+')'}"></span>Português</a></li>
					<li><a class="" href="http://ru.balanatwiremesh.com"><span class="flag_language-pic flag-ru" :style="{backgroundImage:'url('+language_small+')'}"></span>Pусский</a></li>
					<li><a class="" href="http://fr.balanatwiremesh.com"><span class="flag_language-pic flag-fr" :style="{backgroundImage:'url('+language_small+')'}"></span>Français</a></li>
					<li><a class="" href="http://de.balanatwiremesh.com"><span class="flag_language-pic flag-de" :style="{backgroundImage:'url('+language_small+')'}"></span>Deutsch</a></li>
					<li><a class="" href="http://kr.balanatwiremesh.com"><span class="flag_language-pic flag-kr" :style="{backgroundImage:'url('+language_small+')'}"></span>한국어</a></li>
					<li><a class="" href="http://ar.balanatwiremesh.com"><span class="flag_language-pic flag-ar" :style="{backgroundImage:'url('+language_small+')'}"></span>العربية</p></a></li>
					<li><a class="" href="http://nl.balanatwiremesh.com"><span class="flag_language-pic flag-nl" :style="{backgroundImage:'url('+language_small+')'}"></span>Nederlands</a></li>
					<li><a class="" href="http://hi.balanatwiremesh.com"><span class="flag_language-pic flag-hi" :style="{backgroundImage:'url('+language_small+')'}"></span>हिंदी</a></li>                                                    
				</ul>
			</div>
		  </div>
		  
        <div class="navbar-header">
          <a href="index.html" class="navbar-brand">
            <img :src="$logo" alt="" />
          </a>
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
            <span class="sr-only">切换导航</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse" id="navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li :class="{active:isCurrNav(item.to)}" v-for="(item,index) in navs" :key="index">
              <a href="javascript:;" @click="nav_link(item)" v-text="item.name"></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <router-view/>
	<footer>
		<div class="container">
			<ul class="flink" style="display: none;">
				<li><a href="#">链接1</a></li>
				<li><a href="#">链接</a></li>
				<li><a href="#">链接1</a></li>
				<li><a href="#">链接</a></li>
				<li><a href="#">链接1</a></li>
				<li><a href="#">链接</a></li>
			</ul>
			<div class="row">
				<div class="col-md-3">
					<img src="./assets/img/flogo.png">
				</div>
				<div class="col-md-3">
					<p class="fcon">
						{{$website_name}}是一家致力于不锈钢丝网及深加工产品，集研发、生产、销售于一体的工贸一体化企业。生产基地位于中国丝网之乡河北省安平县南部工业园12号。
					</p>
				</div>
				<div class="col-md-4">
					<ul>
						<li>电话/微信：<b>13031839005</b></li>
						<li><span>工厂地址：河北省安平县南部工业园12号</span></li>
						<li><span>邮箱：kellong@meshnb.com</span></li>
					</ul>
				</div>
				<div class="col-md-2 text-right">	
					<img src="./assets/img/conde2.jpg" width="100" alt="">
					<br />
					<span style="display:inline-block; text-align: center; width: 100px;">扫码加微信</span>
					
				</div>
			</div>
		</div>
		<div class="copy-right">CopyRight 2018 All Right Reserved <b>Balanat</b> <a href="https://beian.miit.gov.cn" class="btn btn-link" target="_blank">ICP:{{$icp}}</a></div>
	</footer>
  </div>
</template>
<script>
	import language_small from "./assets/img/language-small.png"
  export default {
      name: 'App',
      data:function () {
        return{
			language_small:language_small,
            navs:[{to:"/",name:"首页"},{to:"/productDetail",name:"产品与服务"},{to:"/aboutus",name:"关于我们"},{to:"/contactus",name:"联系我们"},{link:true,to:"https://www.balanatwiremesh.com",name:"外贸专栏"}]
        }
      },
      created:function () {

      },
      methods:{
          isCurrNav:function (page) {
              var curr = this.$route.path;
              return curr == page;
          },
          nav_link:function (item) {
			  if(item.link)
				window.open(item.to)
			  else
              this.$router.push(item.to);
          }
      }

  }
</script>

<style>
  @import "assets/bootstrap-3.3.7/css/bootstrap.css";
  @import "assets/css/basic.css";
  @import "assets/css/style.css";
  @import "assets/css/zoomify.css";
</style>



// WEBPACK FOOTER //
// src/App.vue